import { Col, Row } from '@workramp/ui';
import { isMobile } from '~/utils';
import { useViewportBreakpoint } from '~/hooks';
import isFeatureEnabled from '~/components/common/is-feature-enabled';
import { AdvancedSearchFilterModal } from '../AdvancedSearchFilterModal';
import { AdvancedSearchFilterSkills } from './AdvancedSearchFilterSkills';
import { AdvancedSearchFilterType } from './AdvancedSearchFilterType';
import { AdvancedSearchFilterUpdatedDate } from './AdvancedSearchFilterUpdatedDate';
import { AdvancedSearchFilterTags } from './AdvancedSearchFilterTags';
import { AdvancedSearchFilterUpdatedBy } from './AdvancedSearchFilterUpdatedBy';
import { AdvancedSearchFilterReset } from './AdvancedSearchFilterReset';

export const AdvancedSearchFilters = () => {
  const viewportBreakpoint = useViewportBreakpoint();

  const isSkillsEnabledInSearch = isFeatureEnabled('fy25_q3_elc_skills_in_search');

  return (
    <Col xs="auto">
      <Row gapX={2} gapY={2} align="center">
        {isMobile(viewportBreakpoint) ? (
          <Col xs="auto">
            <AdvancedSearchFilterModal />
          </Col>
        ) : (
          <>
            {isSkillsEnabledInSearch && (
              <Col xs="auto">
                <AdvancedSearchFilterSkills />
              </Col>
            )}
            <Col xs="auto">
              <AdvancedSearchFilterTags />
            </Col>
            <Col xs="auto">
              <AdvancedSearchFilterType />
            </Col>
            <Col xs="auto">
              <AdvancedSearchFilterUpdatedDate />
            </Col>
            <Col xs="auto">
              <AdvancedSearchFilterUpdatedBy />
            </Col>
            <Col xs="auto">
              <AdvancedSearchFilterReset />
            </Col>
          </>
        )}
      </Row>
    </Col>
  );
};
